export default "__VITE_ASSET__BX2j0j1C__"